import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { artistOnBoardingStages } from '@/pages/artist/onboard/ArtistOnBoarding';
import { redirectUnauthenticated } from '@/shared/helper/redirectUnauthenticated';

const validateParams = z.object({
  step: artistOnBoardingStages
});
const validateSearch = z.object({
  from: z.string().optional()
});

export const Route = createFileRoute('/artist/$id/_onboard/onboard/$step')({
  beforeLoad: ({ context }) => {
    redirectUnauthenticated(context);
  },
  params: validateParams,
  validateSearch
});
